import React, {useState} from 'react';
import Page from "../../../layouts/Main/Page";
import {useNavigate, useParams} from "react-router-dom";
import {useBookingQuery} from "../query";
import BookingActionMenu from "./BookingTopBarMenu";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import BookingHeader from "./BookingHeader";
import BookingItemList from "./BookingItemList";
import useAccommodations from "../../../components/Accommodations/useAccommodations";
import GuestsTab from "./GuestsTab";
import {ALLOGGIATI_STATUS} from "../../../services/bookings/enums";
import PaymentTab from "./PaymentTab/index.js";
import useDialog from "../../../hooks/useDialog";
import EditDialog from "./EditDialog";
import BookingConditionTab from "./BookingConditionTab";
import BookingDocuments from "./BookingDocuments";
import PeopleIcon from '@mui/icons-material/People';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import ChecklistIcon from '@mui/icons-material/Checklist';
import ArticleIcon from '@mui/icons-material/Article';
import {useMainLayout} from "../../../layouts/Main";


const Booking = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [selectedTab, setSelectedTab] = useState("guests")
    const editDialog = useDialog();

    const bookingQuery = useBookingQuery(params.bookingId, {
        refetchInterval: (data) => {
            // Refetch the data if the selected tab is the guests and there is a check in with a
            // scheduled or running Alloggiati Job
            if(selectedTab !== "guests") {
                return null;
            }
            else {
                if (data?.checkIns?.some(c => ALLOGGIATI_STATUS.scheduled === c.alloggiatiJobStatus || ALLOGGIATI_STATUS.running === c.alloggiatiJobStatus)) {
                    return 5000;
                } else{
                    return null;
                }
            }
        }
    });

    const accommodations = useAccommodations();

    const isLoading = bookingQuery.isLoading || accommodations.isLoading;

    const booking = bookingQuery.data;

    return <Page title={isLoading ? "Loading..." : booking.getFullName("Prenotazione senza nome")}
                 subTitle={isLoading ? null : `# ${booking.codeNumber}`}
                 loading={isLoading}
                 onBack={() => navigate(-1)}
                 actions={<BookingActionMenu booking={booking}/>}
                 overlay>
        <Container maxWidth="lg"
                   disableGutters={true}
                   sx={{mb: 4}}>
            <BookingHeader booking={booking} onEdit={editDialog.open} />
            <BookingItemList booking={booking} accommodations={accommodations}/>
            <BookingTab booking={booking}
                        accommodations={accommodations}
                        selectedTab={selectedTab}
                        setSelectedTab={setSelectedTab}/>
        </Container>
        { editDialog.show && <EditDialog booking={booking} onClose={editDialog.close}/>}
    </Page>
}

const BookingTab = ({booking, accommodations, selectedTab, setSelectedTab}) => {
    const {isMobile} = useMainLayout();
    const desktopLabel = (label) => isMobile ? null : label;

    return <Card sx={{mt: 3}}>
        <Box sx={{width: '100%', typography: 'body1'}}>
            <Tabs variant="scrollable"
                  aria-label="booking tabs"
                  value={selectedTab}
                  onChange={(e, newValue) => setSelectedTab(newValue)}>
                <Tab label={desktopLabel("Ospiti/CheckIn")} value="guests" icon={<PeopleIcon />}/>
                <Tab label={desktopLabel("Costi/Pagamenti")} value="payments" icon={<PointOfSaleIcon />}/>
                <Tab label={desktopLabel("Condizioni")} value="bookingConditions" icon={<ChecklistIcon />}/>
                <Tab label={desktopLabel("Documenti")} value="documents" icon={<ArticleIcon />}/>
            </Tabs>
        </Box>
        { selectedTab === "guests" && <GuestsTab booking={booking} accommodations={accommodations} /> }
        { selectedTab === "payments" && <PaymentTab booking={booking} accommodations={accommodations} /> }
        { selectedTab === "bookingConditions" && <BookingConditionTab booking={booking} /> }
        { selectedTab === "documents" && <BookingDocuments booking={booking} /> }
    </Card>
}


export default Booking;